import { render } from "./Empty.vue?vue&type=template&id=714c80c4"
const script = {}
script.render = render

export default script